import styled from 'styled-components'

export const Container = styled.div`
  min-height: calc(100vh - 80px);
`
